module.exports = __webpack_public_path__ + "static/keyboardNav-641ca5e2ca0c9e4920766c57e8a46dca.png";